export const DEFAULT_BENEFIT_CARDS = [
  {
    title: "A packed schedule",
    description:
      "Get ready for three days of disruptive ideas and ground-breaking insights - we’re really proud of the speakers, panels and activities we’ve put together.",
    icon: "/canvas/crosby/icons/icon-1.5fe2c9c5.svg",
  },
  {
    title: "Living it your way",
    description:
      "With multiple thematic tracks you can pick and choose what sessions you want to join and create your own schedule.",
    icon: "/canvas/crosby/icons/icon-2.5a531136.svg",
  },
  {
    title: "Not just watching",
    description:
      "Live Q&As, in-session chat, polls, games, whiteboard and brainstorming sessions... thought this was going to be only about watching people talk? Think again.",
    icon: "/canvas/crosby/icons/icon-3.0b2f8646.svg",
  },
  {
    title: "Food for thought",
    description:
      "We carefully selected our speakers with the goal of bringing really though-provoking, disruptive ideas to the table.",
    icon: "/canvas/crosby/icons/icon-4.c35ed985.svg",
  },
  {
    title: "Meaningful connections",
    description:
      "Be ready to meet other brilliant minds, exchange ideas, network and lay the foundations for new, fruitful partnerships thanks to our Networking area.",
    icon: "/canvas/crosby/icons/icon-5.8b4f8ac5.svg",
  },
  {
    title: "Extra content and recordings",
    description:
      "You’ll have access to all recordings after the event is over, so you can go back an rewatch the sessions you didn’t catch live. We’ll also share slides and more extras.",
    icon: "/canvas/crosby/icons/icon-6.af167f3b.svg",
  },
];
